__turbopack_context__.v({
  "actionsWrapper": "GJshvG_actionsWrapper",
  "alertWindow": "GJshvG_alertWindow",
  "backdrop": "GJshvG_backdrop",
  "icon": "GJshvG_icon",
  "textContainer": "GJshvG_textContainer",
});
